

import { createBundle } from '../../services/subscriptions.services'; 

export const CREATE_BUNDLE_REQUEST = 'CREATE_BUNDLE_REQUEST';
export const CREATE_BUNDLE_SUCCESS = 'CREATE_BUNDLE_SUCCESS';
export const CREATE_BUNDLE_FAILURE = 'CREATE_BUNDLE_FAILURE';

export const createBundleRequest = () => ({
  type: CREATE_BUNDLE_REQUEST,
});

export const createBundleSuccess = (bundle) => ({
  type: CREATE_BUNDLE_SUCCESS,
  payload: bundle,
});

export const createBundleFailure = (error) => ({
  type: CREATE_BUNDLE_FAILURE,
  payload: error,
});

export const createBundleAction = (formData, userData) => async (dispatch) => {
  dispatch(createBundleRequest());
  try {
    const response = await createBundle(formData, userData);
    dispatch(createBundleSuccess(response.data)); // Assuming createBundle returns data
    return response; // Optional: return the response for further handling in components
  } catch (error) {
    dispatch(createBundleFailure(error.message));
    throw error;
  }
};
